import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  filterBuildingsInitAction,
  updateBuildingsFiltersAction,
} from '../../../actions/instances/buildings';
import Api from '../../../services/Api';
import { fetchTagsInitAction } from '../../../actions/tagsActions';
import './TagsWidget.scss';

const TagsWidget = () => {
  const { tagsList } = useSelector(state => state.tags);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  return (
    <section className="widget mt-3">
      <h3 className="title">Tags</h3>
      <div className="tagcloud">
        {tagsList.map(tag => (
          <div className="buttons-wrapper">
            <button
              type="button"
              className="btn btn-light tag-btn"
              onClick={() => {
                if (location.pathname !== 'home') {
                  history.push('/home');
                  window.scrollTo(0, 0);
                }
                dispatch(updateBuildingsFiltersAction([{
                  type: 'tag',
                  value: tag.id,
                  label: tag.name,
                }]));
                setTimeout(() => {
                  dispatch(filterBuildingsInitAction());
                }, 500);
              }}
            >
              {tag.name}
            </button>
            <button
              type="button"
              className="delete-tag"
              onClick={() => {
                Api.delete(`/tags/${tag.id}`).then(() => {
                  dispatch(fetchTagsInitAction());
                });
              }}
            >
              <span>x</span>
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TagsWidget;
